import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { ICountryService } from '../entities/ICountryService';
import { ICountryRepository } from '../entities/ICountryRepository';
import { Country } from '../entities';

export class CountryServiceImpl implements ICountryService {
  itemRepo: ICountryRepository;

  constructor(ir: ICountryRepository) {
    this.itemRepo = ir;

    this.GetCountries = this.GetCountries.bind(this);
  }

  GetCountries(data?: GenericObject): Promise<Country[]> {
    return this.itemRepo.GetCountries(data);
  }
}
